import env from 'enviro';
import { CBX_ADD_ADDITIONAL_CONTACTS_SEATS_TOUCHLESS_FLOW, HIC_UPGRADE_PAGE_POPULAR_FEATURES, SEATS_STARTER_TO_PRO_TOUCHLESS_FLOW_GATE, SEATS_STARTER_TO_PRO_TOUCHLESS_FLOW_WITH_ORDER_SUMMARY_GATE, SEATS_STARTER_TO_STARTER_TOUCHLESS_FLOW_GATE, SSM_JUNE_24_PRICE_CHANGES, SSM_OFFER_HELPER_UTILS_REFACTOR, SSM_OFFER_UTILS_REFACTOR, SSM_PRE_SEATS_FAKE_PUBLIC_PORTAL_GATE } from '../constants/Gates';
import { SEATS_VERSIONS_FEATURE_FLAG, SSM_JUNE_24_PRICE_CHANGES_FLAG, SSM_OFFER_HELPER_UTILS_REFACTOR_FLAG, SSM_OFFER_UTILS_REFACTOR_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { hasAnyMarketingPlusSkuInProductData } from './productsUtils';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from './safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);
  if (override === 'true' && isQA) {
    return true;
  }
  return !!(gates && gates.indexOf(gateKey) !== -1);
};
export const getIsUngatedForSeats = state => {
  const isUngatedByPublicFlagOrOverride = getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  });
  const urlParams = new URLSearchParams(window.location.search);
  const isUngatedByQueryParamOverride = urlParams.get('forceSeatsPricing') === 'true';
  const isUngatedOnPublic = isUngatedByPublicFlagOrOverride || isUngatedByQueryParamOverride;
  return isUngatedOnPublic || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getAreGatesPopulated = state => {
  return state.gates.length > 0;
};
export const getIsUngatedForSeatsStarterToProTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: SEATS_STARTER_TO_PRO_TOUCHLESS_FLOW_GATE
  });
};
export const getIsUngatedForSeatsStarterToProTouchlessFlowWithOrderSummary = state => {
  return getIsUngated(state, {
    gateKey: SEATS_STARTER_TO_PRO_TOUCHLESS_FLOW_WITH_ORDER_SUMMARY_GATE
  });
};
export const getIsUngatedForCBXAddAdditionalContactsSeatsTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: CBX_ADD_ADDITIONAL_CONTACTS_SEATS_TOUCHLESS_FLOW
  });
};
export const getIsUngatedForMarketingPlus = state => {
  return hasAnyMarketingPlusSkuInProductData(state);
};
export const getIsUngatedForPreSeatsFakePublicPortal = state => {
  return getIsUngated(state, {
    gateKey: SSM_PRE_SEATS_FAKE_PUBLIC_PORTAL_GATE
  });
};
export const getIsUngatedForJune24PriceChanges = state => {
  return getIsUngated(state, {
    gateKey: SSM_JUNE_24_PRICE_CHANGES
  }) || getIsUngated(state, {
    gateKey: SSM_JUNE_24_PRICE_CHANGES_FLAG
  });
};
export const getIsUngatedForUpgradePagePopularFeatures = state => {
  return getIsUngated(state, {
    gateKey: HIC_UPGRADE_PAGE_POPULAR_FEATURES
  });
};
export const getIsUngatedForOfferUtilsRefactor = state => {
  return getIsUngated(state, {
    gateKey: SSM_OFFER_UTILS_REFACTOR
  }) || getIsUngated(state, {
    gateKey: SSM_OFFER_UTILS_REFACTOR_FLAG
  });
};
export const getIsUngatedForOfferHelperUtilsRefactor = state => {
  return getIsUngated(state, {
    gateKey: SSM_OFFER_HELPER_UTILS_REFACTOR
  }) || getIsUngated(state, {
    gateKey: SSM_OFFER_HELPER_UTILS_REFACTOR_FLAG
  });
};
export const getIsUngatedForSeatsStarterToStarterTouchlessFlow = state => {
  return getIsUngated(state, {
    gateKey: SEATS_STARTER_TO_STARTER_TOUCHLESS_FLOW_GATE
  });
};